import { Outlet } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import { useAuth } from '@/components/auth';
import { createTimeoutPromise } from '@/utils/helpers';

import LoadingPage from '@/pages/LoadingPage';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import useAsync from '@/hooks/useAsync';

const CONTAINER_STYLE = {
  backgroundColor: '#FFF',
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100%',
  gap: '20px',
};

const SimpleLayout: FC<PropsWithChildren> = ({ children }) => {
  const { loading: loadingAuth } = useAuth();
  const { loading } = useAsync(() => createTimeoutPromise(3000), { immediate: true });
  if (loading || loadingAuth)
    return (
      <Container disableGutters maxWidth="sm" sx={CONTAINER_STYLE}>
        <LoadingPage />
      </Container>
    );
  return (
    <Container disableGutters maxWidth="sm" sx={CONTAINER_STYLE}>
      <Header />
      <Box sx={{ flex: '1 1 0px' }}>{children || <Outlet />}</Box>
      <Footer />
    </Container>
  );
};

export default SimpleLayout;
